import { render, staticRenderFns } from "./tableWidget.vue?vue&type=template&id=01f7788d&"
import script from "./tableWidget.vue?vue&type=script&lang=js&"
export * from "./tableWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports